import React , { useRef, useEffect }from 'react';
import { TestimonialContainer } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';
import { getWebUserId } from '../../../Utils/helper';
import { doc } from 'firebase/firestore';


function NewTestimonialSection(props) {
  const dWebData = [
    'https://images.myloapp.in/NestJsUploads/1728021549834-Dweb-testimonial-1.webp',
    'https://images.myloapp.in/NestJsUploads/1728021549837-Dweb-testimonial-2.webp',
    'https://images.myloapp.in/NestJsUploads/1728021549837-Dweb-testimonial-3.webp',
    'https://images.myloapp.in/NestJsUploads/1728021549838-Dweb-testimonial-4.webp',
  ];
  const mWebData = [
    'https://images.myloapp.in/NestJsUploads/1728022100222-mweb-testimonial-1.webp',
    'https://images.myloapp.in/NestJsUploads/1728022100224-mweb-testimonial-2.webp',
    'https://images.myloapp.in/NestJsUploads/1728022100224-mweb-testimonial-3.webp',
    'https://images.myloapp.in/NestJsUploads/1728022100224-mweb-testimonial-4.webp',
  ];
   // refs for horizontal impression tracking
    const cardsRef = useRef([]);
    const firedImpressionsRef = useRef(new Set());
    const scrollContainerRef = useRef(null);
    const itemRefs = useRef([]); // refs for each testimonial item
   // Use dWebData as testimonials data
   const testimonials = dWebData.map((img, index) => ({
    image: img,
    mobileImage: mWebData[index],
    title: `testimonial_${index + 1}`,
  }));
   const sectionId = 'TestinomialSection';

  


    useEffect(() => {
      for (let i = 0; i < testimonials.length; i++) {
       
        const video = document.getElementById(`${sectionId}-${i}`);
    
        if (video) {
     
          const options = {
            root: null, // use the viewport
            rootMargin: '0px',
            threshold: 0.18, // 50% of the video is visible
          };
  
          const handleIntersection = (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting ) {
               
                
                if (firedImpressionsRef.current.has(i)) return;
  
                firedImpressionsRef.current.add(i);
                const item = testimonials[i];
                const productData = item?.productData || {};
  
               const t = testimonials[i] || {};
          const product = t.product || {};
            fireEvent({
            category: 'Impression_card_in_store_home',
            card_name: t.title || t.heading || 'testimonial_card',
            product_id: product.id || product._id || 'NA',
            user_data: {
              user_id: getWebUserId() || 'NA',
           
            },
            query_params:
              typeof window !== 'undefined'
                ? window.location.search || 'NA'
                : 'NA',
                 screen_name: 'Store',
                 section_name: 'Testimonial Section' ,
          });
              } else {
               
              }
            });
          };
  
          const observer = new IntersectionObserver(handleIntersection, options);
          observer.observe(video);
        }
      }
    }, [testimonials]);

  return (
    <TestimonialContainer >
      <p className="head">
        Real people, <span className="subHead">Real results</span>
      </p>
      <div className="container" >
        {dWebData?.map((ele, index) => {
          return (
            <div    id={`${sectionId}-${index}`}    key={'test' + index} className="imageContainer"
            ref={(el) => {
              if (el) itemRefs.current[index] = el;
            }}
            data-index={index}
            >
              <img className="mobile" src={mWebData[index]} alt="" />
              <img className="desktop" src={ele} alt="" />
            </div>
          );
        })}
      </div>
    </TestimonialContainer>
  );
}

export default NewTestimonialSection;
